import { gql } from '@apollo/client';

export const NEW_ANIMAL_UNIT = gql`
  fragment NewAnimalUnit on AnimalUnit {
    id
  }
`;
